import { FileCogIcon } from './FileCogIcon';

/**
 * author: Simran
 * id 73890E82-6C92-4578-B1D4-51D83CB5DDDE
 * name file-cog
 * version: 4.2.95
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/file-cog.svg
 * tags
 * - Settings 
 * - Files / Folders 
 */
export const FileSettingsCogIcon = FileCogIcon;
export default FileSettingsCogIcon